import i18n from "i18next";
import React from "react";
import { ResponsiveImage, Sizes, SrcSet } from "../components/ResponsiveImage.component";
import { ImageAssetInterface } from "../decoders/PubSub.types";
import { placeholderImage } from "../lib/image";
import { MagicLink } from "../ui";

export const generateImageAssetSizes = (imgUrl: string) => {
    const srcset: SrcSet[] = [
        {
            url: `${imgUrl}?ops=max(360,0),quality(70)`,
            descriptor: "360w",
        },
        {
            url: `${imgUrl}?ops=max(480,0),quality(80)`,
            descriptor: "480w",
        },
        {
            url: `${imgUrl}?ops=max(650,0),quality(80)`,
            descriptor: "650w",
        },
        {
            url: `${imgUrl}?ops=max(1060,0),quality(80)`,
            descriptor: "940w",
        },
    ];
    const sizes: Sizes[] = [
        {
            media: "(max-width: 361px)",
            size: "360px",
        },
        {
            media: "(max-width: 481px)",
            size: "480px",
        },
        {
            media: "(max-width: 651px)",
            size: "650px",
        },
        {
            media: "(min-width: 1060px)",
            size: "940px",
        },
        {
            media: "auto",
            size: "",
        },
    ];
    const placeholderSrcset: SrcSet[] = [
        {
            url: `${placeholderImage}?ops=max(360,0),quality(70)`,
            descriptor: "360w",
        },
        {
            url: `${placeholderImage}?ops=max(480,0),quality(80)`,
            descriptor: "480w",
        },
        {
            url: `${placeholderImage}?ops=max(650,0),quality(80)`,
            descriptor: "650w",
        },
        {
            url: `${placeholderImage}?ops=max(1060,0),quality(80)`,
            descriptor: "940w",
        },
    ];

    return { srcset, sizes, placeholderSrcset };
};

export const ImageAssetLegacy = (props: ImageAssetInterface) => {
    const caption = props.use_caption && props.caption ? props.caption : null;
    const altText = props.title || props.alt_text || "";
    const { srcset, sizes } = generateImageAssetSizes(props.imgUrl);
    const placeholderSrc = `${placeholderImage}?ops=resize(900,506),quality(10)`;

    return (
        <figure className="component-image-asset">
            {props.counter ? <section className="image-counter">{props.counter}</section> : null}
            <section className="image-container">
                {props.url ? (
                    <MagicLink to={props.url} target={props.new_tab ? "_blank" : "_self"}>
                        <ResponsiveImage
                            src={placeholderSrc}
                            placeholder={placeholderSrc}
                            alt={altText}
                            srcset={srcset}
                            sizes={sizes}
                            initialWidth={288}
                            initialHeight={162}
                        />
                    </MagicLink>
                ) : (
                    <ResponsiveImage
                        src={placeholderSrc}
                        placeholder={placeholderSrc}
                        alt={altText}
                        srcset={srcset}
                        sizes={sizes}
                        initialWidth={288}
                        initialHeight={162}
                    />
                )}
            </section>
            {caption || props.source_credit ? (
                <figcaption>
                    {caption}
                    {props.source_credit ? (
                        <p className="image-credit">
                            {i18n.t("photo")}: {props.source_credit}
                        </p>
                    ) : null}
                </figcaption>
            ) : null}
        </figure>
    );
};

export default ImageAssetLegacy;
